import { Cohort, TEST_SEGMENTS } from 'root-constants'

export const AYAH_99_TEXT_CONTEXT_BY_VARIANT: Record<string, string> = {
  [TEST_SEGMENTS.VARIANT_B]: 'rizq',
  [TEST_SEGMENTS.VARIANT_C]: 'exit',
}

export const COHORTS_WITHOUT_TRUSTPILOT_BANNER: Cohort[] = [
  Cohort.AP_FINANCE_313_AM,
  Cohort.AP_FINANCE_313_C_AM,
]
